import { React, useEffect, useState } from 'react';
import 'font-awesome/css/font-awesome.min.css';
import '../assets/css/footer.css'
const queryString = require("query-string")
import useDataStore from '../store/dataStore';
let parsed;

export default function Footer() {
  const [utm, setUtm] = useState("")
  const curr_year = new Date().getFullYear();
  const data = useDataStore((state) => state.data);

  parsed = queryString.parse(window.location.search)
  const terms_condition_url = "/terms-and-conditions?" + "utm_source=" + parsed.utm_source;

  // We are palnning to move this to landing page config in the future
  return parsed.utm_source != 'cisco_systems' && (
    <div className="footer_homepage footer_content">
      
        <p> <a href={terms_condition_url} target={'_blank'}>Terms And Conditions</a></p>
        <div className="fa fa-envelope fa-lg">
          :{(data && data.partnerContactEmail) || 'doctorconsultations@medibuddy.in'}
        </div>
        <div className="fa fa-phone fa-lg" style={{ marginTop: "15px"}}>
          :{(data && data.partnerContactPhone) || '08045686596'}
        </div>
      <p > Copyright {curr_year} MediBuddy</p>
    </div>
  );
}